<template>
    <div class="xhrank25">
        <div class="xhtitle">
            <img src="https://oss.mcloud.moveclub.cn/2025/rank.png" />
            <div>每日前10局AI对战计入排行榜</div>
        </div>
        <div class="tabs">
            <div :class="['tab', type == 1?'active':'']" @click="check(1)">积分排名</div>
            <div :class="['tab', type == 2?'active':'']" @click="check(2)">胜率排名</div>
        </div>
        <div class="main">
            <div class="myinfo">
                <div>
                    <img :src="myinfo.avatar" />
                    <div>
                        <!-- <div>{{ myinfo.nickname }}</div> -->
                        <div>当前用户</div>
                        <div class="myrank">
                            <template v-if="+myinfo.rank > 0 && (
                                (type == 1 && +myinfo.score > 0) ||
                                (type == 2 && myinfo.win_count > 12)
                            )">排名 {{ myinfo.rank }}</template>
                            <template v-else>暂无排名</template>
                        </div>
                    </div>
                    
                    
                </div>
                <div v-if="type==1">
                    <div>{{myinfo.score}} 分</div>
                </div>
                <div v-else>
                    <div v-show="myinfo.rank>0" style="font-size:.3rem;text-align:right;">{{myinfo.win_rate}}%</div>
                    <div v-show="myinfo.rank>0" style="font-size:.2rem">胜{{myinfo.win_count}}场 | 总{{myinfo.total_matches}}场</div>
                </div>
            </div>
            <div class="line"></div>
            <List
            v-model="loading"
            :finished="finished"
            finished-text=""
            @load="init"
            >
                <div class="rank-list">
                    <CellGroup style="border-radius:.16rem" v-if="rankList.length" :border="false">
                    <Cell v-for="item in rankList" :key="item.id" center  class="rank">
                        <!-- <div slot="title">{{item.name||item.nickname}}</div> -->
                        <div slot="title"></div>
                        <div slot="icon" class="rank_icon">

                        <span>{{ item.rank }}</span>
                        <VanImage :src="item.avatarurl" />
                        </div>
                        <div
                        slot="label"
                        v-if="item.create_time"
                        >{{ (systime - item.create_time) | diffentTime(item.create_time) }}</div>


                        <span v-if="type==1"> {{ item.score*1 }} 分</span>
                        <span v-else>
                            <div style="font-size:.24rem">{{item.win_rate}}%</div>
                            <div style="font-size:.2rem">胜{{item.win_count}}场 | 总{{item.total_matches}}场</div>
                        </span>

                    </Cell>
                    </CellGroup>
                    <Empty
                    style="min-height: 6rem;border-radius:.16rem"
                    v-else
                    description="暂无数据"
                    />
                </div>
            </List>
        </div>
        
    </div>
</template>
<script>
import moment from "moment";
import "./index.less";

import { Empty, Panel, Cell, CellGroup, Image, List, Row, Col, Popup, Sticky } from "vant";
export default {
    components: {
        Empty,
        Panel,
        Cell,
        CellGroup,
        List,
        VanImage: Image,
        Row,
        Col,
        Popup,Sticky
    },
    data() {
        return {
            page: 1,
            loading: false,
            finished: false,
            myinfo: {},
            rankList: [],
            type: 1
        }
    },
    methods: {
        check(type) {
            this.type = type
            this.finished = false
            this.loading = false
            this.page = 1
            this.rankList = []
        },
        init() {
            if(this.type == 1) {
                this.$api.sports
                .compareRankAll(
                    Object.assign({
                    cpgid: this.$route.params.cpgid,
                    page: this.page
                    })
                )
                .then((res) => {
                    if (+res.status !== 200) {
                    this.finished = true;
                    return;
                    }
                    this.systime = res.sys_time;
                    this.loading = false;
                    let {
                    list,
                    page,
                    pages,
                    myinfo
                    } = res.data;
                    this.myinfo = myinfo;
                    this.rankList = list;

                    let t = null

                    this.rankList.forEach((item, index) => {
                        if(t == null){
                            t =  item;
                            t.rank = index+1;
                        }else{
                            var n = item;
                            if(n.score*1 == t.score*1){
                                n.rank = t.rank;
                            }else{
                                n.rank = index+1;
                            }
                            t = n;
                        }
                    })
                    this.finished = true;
                });
            } else {
                this.$api.sports
                .winrateRank(
                    Object.assign({
                    cpgid: this.$route.params.cpgid,
                    page: this.page
                    })
                )
                .then((res) => {
                    if (+res.status !== 200) {
                    this.finished = true;
                    return;
                    }
                    this.systime = res.sys_time;
                    this.loading = false;
                    let {
                    list,
                    page,
                    pages,
                    myinfo
                    } = res.data;
                    this.myinfo = myinfo;
                    this.rankList = list;

                    let t = null

                    this.rankList.forEach((item, index) => {
                        if(t == null){
                            t =  item;
                            t.rank = index+1;
                        }else{
                            var n = item;
                            if(n.score*1 == t.score*1){
                                n.rank = t.rank;
                            }else{
                                n.rank = index+1;
                            }
                            t = n;
                        }
                    })
                    this.finished = true;
                });
            }      
        }
    }
}
</script>